import '.bq{line-height:var(--line-height-body);}.ssr-plugin'
import '.bp{margin-top:0px;}.ssr-plugin'
import '.br{margin-bottom:1.5rem;}.ssr-plugin'
import { styled, Style } from 'inlines'

interface OrderedListProps extends React.HTMLAttributes<HTMLOListElement> {
  style?: Style
}

export const OrderedList = ({ children, style, ...rest }: OrderedListProps) => {
  return (
    <styled.ol className="bq bp br"
      {...rest}
      style={{
        '& > li': { marginTop: 0, marginBottom: '1rem' },
        ...style,
      }}
    >
      {children}
    </styled.ol>
  )
}
